import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/shared/button';
import { BUTTON_SIZES } from 'constants/button';
import styles from './styles.module.scss';

const PropertyBox = ({ title, desc, onPress }) => {
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setDisabled(false);
    }, 2000);
  }, []);

  return (
    <div className={styles.sampleBox}>
      <div className={styles.sampleTxt}>
        <h4>{title}</h4>
        <p>{desc}</p>
      </div>
      <div>
        <Button
          type="button"
          theme="accent-primary"
          size={BUTTON_SIZES.SM}
          onClick={onPress}
          disabled={disabled}
          loading={disabled}
        >
          Try Now
        </Button>
      </div>
    </div>
  );
};

PropertyBox.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
};

export default PropertyBox;
